import { createFileRoute } from '@tanstack/react-router';
import { Error } from '~/pages';
import { zodValidator } from '@tanstack/zod-adapter';
import z from 'zod';

const errorSearchParamsSchema = z.object({
  type: z.string().optional().default(''),
  value: z.string().optional().default('unknown'),
});

export const Route = createFileRoute('/error')({
  component: Error,
  validateSearch: zodValidator(errorSearchParamsSchema),
});
